import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { AuthService, INavBarItem, NAV_BAR_ITEMS, navBarItemsProvider } from '@telespot/web-core';
import { environment } from '@telespot/shared/environment';
import { map } from 'rxjs/operators';

import { Observable } from 'rxjs';

@Component({
    selector: 'ts-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss'],
    providers: [navBarItemsProvider],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NavBarComponent {
  @Input() showLogo: boolean;
  @Input() isDevVersion = false;
  @Input() sidenav: MatSidenav;

  public readonly version = environment.VERSION;
  public readonly currentUser$ = this.authService.currentUser$;
  public readonly currentOrganization$ = this.authService.currentOrganization$;
  public readonly mobile$ = this.breakpoint
    .observe([Breakpoints.HandsetPortrait, Breakpoints.Small])
    .pipe(map((v) => v.matches));

  constructor(
    private authService: AuthService,
    private breakpoint: BreakpointObserver,
    @Inject(NAV_BAR_ITEMS) public links: Observable<INavBarItem[]>
  ) {}
}
